// Per-hostname logo override for multi-domain (Option B) tenants — e.g. a single
// UPMI box serving both ultraproactive.ph and promag300premier.com wants a
// different logo per domain. The map is baked at build time into the
// `__TENANT_LOGO_HOST_OVERRIDES__` define (from the tenant preset's
// `logoHostOverrides`), so the correct logo is known on the FIRST paint with no
// /tenant/config round-trip and no flash.

const HOST_LOGO_OVERRIDES: Record<string, string> = __TENANT_LOGO_HOST_OVERRIDES__ || {};

/**
 * The logo path override for the CURRENT hostname, or `null` when none matches.
 * Keys are bare, registrable-ish hostnames and are SUFFIX-matched so
 * `www.`/`member.` subdomains match (`host === key || host.endsWith('.'+key)`),
 * while `notultraproactive.ph` does not. SSR/no-window safe; case-insensitive.
 */
export function hostLogoOverride(): string | null {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname.toLowerCase();
  for (const [key, url] of Object.entries(HOST_LOGO_OVERRIDES)) {
    const k = key.toLowerCase();
    if (host === k || host.endsWith('.' + k)) return url;
  }
  return null;
}
